export default __webpack_public_path__ + "static/media/launch-white.a3167c6b.svg";